import { Link } from "react-router-dom";
import { Footer } from "@/components/activehuman/Footer";

const PrivacyPolicy = () => {
  return (
    <div data-testid="privacy-page" className="bg-[#FDFBF7] text-[#1A362D] min-h-screen">
      <header className="border-b border-[#E5E8E3]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" data-testid="privacy-back-home" className="font-serif-display text-2xl">
            activehuman<span className="text-[#C29B62]">.</span>
          </Link>
          <Link to="/" className="text-sm uppercase tracking-[0.2em] text-[#1A362D] activehuman-link-underline">
            ← Back home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="text-xs uppercase tracking-[0.28em] text-[#C29B62] font-semibold mb-4">Legal</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A362D] tracking-tight font-medium leading-tight">
          Privacy Policy
        </h1>
        <p className="mt-4 text-sm text-[#4A5D56]">Last updated: December 2025 · Placeholder</p>

        <div className="mt-12 space-y-6 text-[#4A5D56] font-light text-base md:text-lg leading-relaxed">
          <p>
            Activehuman ("we", "us") respects your privacy. This placeholder Privacy Policy describes, in general terms,
            how we plan to handle information you choose to share with us prior to and after our launch.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">
            Information we collect
          </h2>
          <p>
            At present, the only information we may collect is the email address you voluntarily submit through our
            "Notify Me" form, to let you know when our products launch.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">How we use it</h2>
          <p>
            Your email will be used solely to send you launch-related updates from Activehuman. We will not sell, rent
            or share your information with unrelated third parties.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">Your choices</h2>
          <p>
            You can request removal of your email from our list at any time by writing to{" "}
            <a className="activehuman-link-underline text-[#1A362D]" href="mailto:hello@theactivehuman.com">
              hello@theactivehuman.com
            </a>
            .
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">Contact</h2>
          <p>
            For any privacy-related questions, contact us at{" "}
            <a className="activehuman-link-underline text-[#1A362D]" href="mailto:hello@theactivehuman.com">
              hello@theactivehuman.com
            </a>
            .
          </p>

          <p className="text-sm pt-8 italic text-[#4A5D56]/80">
            This is a placeholder policy intended for our pre-launch FSSAI documentation. A full, definitive version
            will be published before any product sale begins.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
